import { Modal } from "antd";
import CreateRoleForm from "./CreateRoleForm";

const EditRole = ({ role, isOpen, closeModal, callback }) => {
  return (
    <Modal
      title={<></>}
      width="500px"
      open={isOpen}
      onCancel={closeModal}
      className="user-popup"
      footer={false}
    >
      <div className="mt20">
        <CreateRoleForm
          initialValues={role}
          closeModal={closeModal}
          callback={callback}
        />
      </div>
    </Modal>
  );
};

export default EditRole;
